import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c5c2c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-sm" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col-6" }


import { openInNewWindow } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  bookHash: { type: String, required: true },
  sheetHash: { type: String, required: true },
},
  setup(__props) {

// TODO: defineProps インポートしないとエラーが出るのでひとまずそのまま


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$q.screen.lt.sm ? '' : 'q-px-lg')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          outline: "",
          color: "primary",
          size: "lg",
          padding: "9px 5px",
          style: _normalizeStyle([{"border":"3px solid #1976d2"}, _ctx.$q.screen.lt.sm ? 'font-size: 16px;' : '']),
          label: "設定する",
          class: "full-width",
          to: { path: 'book', query: { cd: __props.bookHash }, hash: '#setting' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              size: "1.2em",
              style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'margin-left: 6px;' : 'margin-left: 14px'),
              name: "far fa-file-alt"
            }, null, 8, ["style"])
          ]),
          _: 1
        }, 8, ["style", "to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_btn, {
          outline: "",
          color: "primary",
          size: "lg",
          padding: "9px 5px",
          style: _normalizeStyle([{"border":"3px solid #1976d2"}, _ctx.$q.screen.lt.sm ? 'font-size: 16px;' : '']),
          label: "配布する",
          class: "full-width",
          to: { path: 'book', query: { cd: __props.bookHash }, hash: '#publish' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              size: "1.2em",
              style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'margin-left: 6px;' : 'margin-left: 14px'),
              name: "fas fa-paper-plane"
            }, null, 8, ["style"])
          ]),
          _: 1
        }, 8, ["style", "to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_btn, {
          outline: "",
          color: "primary",
          size: "lg",
          padding: "9px 5px",
          style: _normalizeStyle([{"border":"3px solid #1976d2"}, _ctx.$q.screen.lt.sm ? 'font-size: 16px;' : '']),
          label: "回答結果を見る",
          class: "full-width",
          to: { path: 'result', query: { cd: __props.bookHash } }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              size: "1.2em",
              style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'margin-left: 6px;' : 'margin-left: 14px'),
              name: "far fa-list-alt"
            }, null, 8, ["style"])
          ]),
          _: 1
        }, 8, ["style", "to"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_btn, {
          outline: "",
          color: "primary",
          size: "lg",
          padding: "9px 5px",
          style: _normalizeStyle([{"border":"3px solid #1976d2"}, _ctx.$q.screen.lt.sm ? 'font-size: 16px;' : '']),
          label: "回答画面を見る",
          class: "full-width",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openInNewWindow)(`./sheet?cd=${__props.sheetHash}`)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              size: "1.2em",
              style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'margin-left: 6px;' : 'margin-left: 14px'),
              name: "open_in_new"
            }, null, 8, ["style"])
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ])
  ], 2))
}
}

})